export const isArray = (input: any): boolean => {
  let isArrayOnly = false;
  if (input instanceof Array) {
    isArrayOnly = true;
  }
  return isArrayOnly;
};

export const isArrayIterable = (input: any): boolean => {
  let isIterable = false;
  if (input instanceof Array) {
    if (input.length > 0) {
      isIterable = true;
    }
  }
  return isIterable;
};
